import type { Distance } from "@pdfking/math"

import type { BoxPointList } from "#internal"

/** A quarter curve `dx`, `dy` on from where the line is, as relative steps
 * (see PointAccumulate): leaving `along` x or y and arriving along the other,
 * its control at the corner it rounds, so it runs on smoothly from straight
 * edges either side. */
export const Corner = (dx: number, dy: number, along: "x" | "y"): BoxPointList => {
  const control = along === "x" ? { x: dx, y: 0 } : { x: 0, y: dy }
  return [
    { x: control.x as Distance, y: control.y as Distance, control: true },
    { x: (dx - control.x) as Distance, y: (dy - control.y) as Distance },
  ]
}
